// extracted by mini-css-extract-plugin
export default {"title":"styles_title__i+I84","desc":"styles_desc__S2SZ3"};